import React, { useEffect, useState, useCallback } from "react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import ReusableSearchInput from "../../../components/ReusableSearchInput";
import MonthDatePicker from "../../../components/MonthDatePicker";
import { generateWeeksInMonth } from "../../../helper/convertionHealper";
import moment from "moment";
import CustomTimeSheetTable from "../../../components/CustomTimeSheetTable";
// import { useLoading } from "../../../context/LoadingContext";

const ExportTimesheetsReportPage: React.FC = () => {
  //   const { isLoading } = useLoading();
  const [selectedWeek, setSelectedWeek] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [userName, setUserName] = useState<string>("");
  const [userID, setUserID] = useState<number | null>(null);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [timesheetData, setTimesheetData] = useState<
    { start: Date; end: Date; userId: number }[]
  >([]);
  const [viewTimesheet, setViewTimesheet] = useState<{
    start: Date;
    end: Date;
    userId: number;
  } | null>(null);

  useEffect(() => {
    if (userID && startDate) {
      const fetchTimesheetData = async () => {
        setErrorMessage("");
        if (userID === null) {
          setErrorMessage("Please Select Employee Name");
          return;
        }

        if (!startDate) {
          setErrorMessage("Please Select Month");
          return;
        }

        const weeks = generateWeeksInMonth(startDate, userID);
        console.log("Generated weeks:", weeks);

        setTimesheetData(weeks);
      };
      fetchTimesheetData();
    }
  }, [userID, startDate]);

  const refreshTable = () => {
    setUserName("");
    setUserID(null);
    setStartDate(null);
    setTimesheetData([]);
    setErrorMessage("");
    setViewTimesheet(null);
  };

  // Wrap the setViewTimesheet function in useCallback to prevent unnecessary re-renders
  const handleViewTimesheet = useCallback(
    (item: { start: Date; end: Date; userId: number }) => {
      setSelectedWeek(item.start.toDateString());
      setViewTimesheet(item);
    },
    []
  );

  return (
    <div>
      <div className="max-w-7xl gap-x-6 gap-y-4 grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 ">
        <div>
          <label
            htmlFor="employeeName"
            className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400"
          >
            Employee Name
          </label>
          <div className="mt-2">
            <ReusableSearchInput
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              setOptionsData={(item) => {
                setUserID(item?.iontime_id ?? null);
                setUserName(item?.ldap_uid ?? "");
              }}
            />
          </div>
        </div>
        <div>
          <label
            htmlFor="month"
            className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400"
          >
            Month
          </label>
          <div className="mt-2">
            <MonthDatePicker
              onChange={setStartDate}
              selectedDate={startDate}
              isClearable={true}
              maxDate={new Date()}
              dateFormat="MM/yyyy"
            />
          </div>
        </div>

        <div className="flex space-x-4">
          <button
            onClick={refreshTable}
            className="flex items-center px-4 py-2 lg:mt-9 text-sm bg-red-700 hover:bg-red-800 text-white rounded-lg focus:outline-none"
          >
            <ArrowPathIcon className="h-5 w-5 text-white mr-2" /> Reset
          </button>
        </div>
      </div>
      {timesheetData.length > 0 && (
        <h4 className="mt-4 mb-3 font-bold">Timesheet Period</h4>
      )}

      <div className="max-w-7xl gap-x-6 gap-y-4 grid gap-3 grid-cols-1 sm:grid-cols-3 md:grid-cols-4 mb-4">
        {errorMessage && (
          <p className="my-2 text-sm text-red-600">{errorMessage}</p>
        )}

        {timesheetData.length > 0 &&
          timesheetData.map((item) => (
            <span
              key={item.start.toDateString()}
              onClick={() => handleViewTimesheet(item)}
              className={`bg-gray-100 ${
                item.start === viewTimesheet?.start &&
                "bg-yellow-100 border-yellow-500"
              } text-center cursor-pointer hover:bg-gray-400 text-gray-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-400 border border-gray-500`}
            >
              {moment(item.start).format("MMM D, YYYY")} -{" "}
              {moment(item.end).format("MMM D, YYYY")}
            </span>
          ))}
      </div>

      {viewTimesheet && (
        <CustomTimeSheetTable
          key={selectedWeek}
          previewFlag={false}
          memberID={viewTimesheet?.userId}
          startDate={viewTimesheet?.start}
          endDate={viewTimesheet?.end}
          employeeNameData={userName}
          employeeIDData={null}
          reportType="approvereject"
          showapproveReject={false}
          showExportButton={true}
          userRoleType={"finance"}
        />
      )}
    </div>
  );
};

export default ExportTimesheetsReportPage;
